(function () {
  var KEY = 'cv_wishlist';
  var CFG = window.__cvWishlistConfig || {};
  var isLoggedIn = !!(CFG.customerId && CFG.token && CFG.workerUrl);
  var syncTimer = null;
  var loginPromptShown = false;

  function getItems() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  function saveLocal(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    updateCount();
  }

  function updateCount() {
    var n = getItems().length;
    document.querySelectorAll('.cv-wishlist-count, [data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function toggle(handle, id) {
    var items = getItems();
    var exists = items.find(function (x) { return x.handle === handle || String(x.id) === String(id); });
    if (exists) {
      items = items.filter(function (x) { return x.handle !== handle && String(x.id) !== String(id); });
    } else {
      items.push({ handle: handle, id: id });
      if (!isLoggedIn && items.length === 1) showLoginPrompt();
    }
    saveLocal(items);
    syncToServer(items);
  }

  function isActive(handle, id) {
    return !!getItems().find(function (x) { return x.handle === handle || String(x.id) === String(id); });
  }

  function workerHeaders() { return { 'Content-Type': 'application/json', 'X-CV-Token': CFG.token }; }
  function workerBaseUrl() { return CFG.workerUrl + '/wishlist?cid=' + CFG.customerId; }

  function syncToServer(items) {
    if (!isLoggedIn) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch(workerBaseUrl(), { method: 'POST', headers: workerHeaders(), body: JSON.stringify({ items: items !== undefined ? items : getItems() }) }).catch(function () {});
    }, 800);
  }

  function syncFromServer() {
    if (!isLoggedIn) return;
    var localItems = getItems();
    fetch(workerBaseUrl(), { headers: workerHeaders() })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var serverItems = (data && Array.isArray(data.items)) ? data.items : [];
        var merged = serverItems.slice();
        localItems.forEach(function (local) {
          var exists = merged.find(function (s) { return (local.handle && s.handle === local.handle) || (local.id && String(s.id) === String(local.id)); });
          if (!exists) merged.push(local);
        });
        if (merged.length > serverItems.length) syncToServer(merged);
        saveLocal(merged);
        refreshAllButtons();
        document.dispatchEvent(new CustomEvent('cvWishlist:synced'));
      })
      .catch(function () { updateCount(); refreshAllButtons(); });
  }

  function refreshAllButtons() {
    document.querySelectorAll('.btn-wishlist, [data-cv-pdp-wishlist]').forEach(function (btn) {
      var handle = btn.dataset.handle || btn.dataset.productHandle || (window.location.pathname.split('/products/')[1] || '').split(/[?#]/)[0] || '';
      var id = btn.dataset.productId || '';
      var active = isActive(handle, id);
      btn.classList.toggle('is-active', active);
      btn.classList.toggle('is-wishlisted', active);
      var textEl = btn.querySelector('.btn-wishlist--product__text');
      if (textEl) textEl.textContent = active ? 'Guardado nos favoritos' : 'Guardar nos favoritos';
    });
  }

  function bindButtons() {
    document.querySelectorAll('.btn-wishlist, [data-cv-pdp-wishlist]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var handle = btn.dataset.handle || btn.dataset.productHandle || (window.location.pathname.split('/products/')[1] || '').split(/[?#]/)[0] || '';
      var id = btn.dataset.productId || '';
      function refresh() {
        var active = isActive(handle, id);
        btn.classList.toggle('is-active', active);
        btn.classList.toggle('is-wishlisted', active);
        var textEl = btn.querySelector('.btn-wishlist--product__text');
        if (textEl) textEl.textContent = active ? 'Guardado nos favoritos' : 'Guardar nos favoritos';
      }
      refresh();
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(handle, id); refresh(); });
    });
  }

  function showLoginPrompt() {
    if (loginPromptShown) return;
    if (sessionStorage.getItem('cv_login_prompt_dismissed')) return;
    loginPromptShown = true;
    var el = document.createElement('div');
    el.id = 'cv-login-prompt';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<button id="cv-login-prompt-close" aria-label="Fechar" style="position:absolute;top:10px;right:12px;background:none;border:none;cursor:pointer;font-size:16px;color:#999;line-height:1;padding:0;">&times;</button><p style="margin:0 0 4px;font-size:0.8rem;letter-spacing:0.06em;text-transform:uppercase;color:#aaa;">Favoritos</p><p style="margin:0 0 12px;font-size:0.88rem;line-height:1.5;color:#333;">Inicia sessão para guardar os teus favoritos em todas as tuas visitas.</p><a href="/account/login" style="display:inline-block;padding:8px 20px;background:#1a1a1a;color:#fff;font-size:0.75rem;letter-spacing:0.08em;text-transform:uppercase;text-decoration:none;">Iniciar sessão</a>';
    el.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:9999;background:#fff;border:1px solid #e5e5e5;padding:18px 20px;max-width:260px;box-shadow:0 4px 16px rgba(0,0,0,0.08);animation:cvPromptIn 0.3s ease;';
    var anim = document.createElement('style');
    anim.textContent = '@keyframes cvPromptIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}';
    document.head.appendChild(anim);
    document.body.appendChild(el);
    function dismiss() { sessionStorage.setItem('cv_login_prompt_dismissed', '1'); el.style.opacity = '0'; el.style.transition = 'opacity 0.2s'; setTimeout(function () { el.remove(); }, 200); }
    document.getElementById('cv-login-prompt-close').addEventListener('click', dismiss);
    setTimeout(dismiss, 8000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (isLoggedIn) { syncFromServer(); } else { updateCount(); }
    bindButtons();
    setInterval(bindButtons, 1500);
  });

  window.cvWishlist = { toggle: toggle, get: getItems, toggleWishlist: toggle, getWishlist: getItems, syncFromServer: syncFromServer, syncToServer: syncToServer };
})();